<template>
<div class="popup-new features" data-popup="popup-1" id="view_advanced_information">
<div class="popup-inner">
  <!--CLOSE EVENT-->
  <a class="popup-close" data-toggle="modal" data-target="#view_advanced_information" href="#"><img src="../../assets/cross.png"></a>
  <div class="wrap-popup" style="overflow: hidden; height: 100%;">
    <!--SLIDE CONTENT Examples of feature -->
    <div id="featuresShow" style="display: none;" class="tile">
      <div class="back-arrow __web-inspector-hide-shortcut__" @click="showPopup('close', null)">
        <a href="#"><img src="../../assets/ic_back.png"></a>
      </div>
      <feature-examples v-bind:feature="chosenFeature"></feature-examples>
    </div>
    <!--Chapter 1 View advanced information INNER CONTENT-->
    <div id="features-hide2">
      <div class="txt-box">
        <div class="img-txt">
          <img src="../../assets/Microscope-Outline-white1.png">
          <h2 class="white"><strong>Text Classification - {{ chunkName }}</strong> View advanced information</h2>
          <div class="i-doc white float-left"><i class="fas fa-info-circle fa-lg" @click="openHelpTab"></i></div>
        </div>
      </div>

      <div class="text">
        <div v-bind:class="textColor(chunkResults)"></div>
        <div class="row">
          <div class="col-xs-1">
            <img style="margin: 9px 0 0 0; width: 25px; float: right;" src="../../assets/Lowercase-Outline1.png">
          </div>
          <div class="col-xs-11" style="margin-left: -15px;">
            <div class="row">
              <div class="col-xs-2">
                <p><strong>Classification </strong></p>
              </div>
              <div class="col-xs-10">
                <p>{{ chunkResults.classifiedAs }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-2">
                <p><strong>Confidence </strong></p>
              </div>
              <div class="col-xs-10">
                <p v-if="chunkResults.confidence <= 0.75">Low</p>
                <p v-if="chunkResults.confidence > 0.75 && chunkResults.confidence < 0.9">Medium</p>
                <p v-if="chunkResults.confidence >= 0.9">High</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="popup-holder">
        <div class="baron">
          <div id="scrollable266" class="baron__scroller">
            <table>
              <thead>
              <tr>
                <th>
                  <div class="btn-vertical">
                    <a href="#" @click="sortBy('Feature')" v-if="sorting('Feature', 'up')" class="btn-top"><i class="fa fa-caret-up"></i></a>
                    <a href="#" @click="sortBy('Feature')" v-if="sorting('Feature', 'down')" class="btn-bottom"><i class="fa fa-caret-down"></i></a>
                  </div>
                  <p class="non-para" @click="sortBy('Feature')">Feature</p>
                </th>
                <th style="width: 17%">
                  <div class="btn-vertical">
                    <a href="#" @click="sortBy('FreqInDoc')" v-if="sorting('FreqInDoc', 'up')" class="btn-top"><i class="fa fa-caret-up"></i></a>
                    <a href="#" @click="sortBy('FreqInDoc')" v-if="sorting('FreqInDoc', 'down')" class="btn-bottom"><i class="fa fa-caret-down"></i></a>
                  </div>
                  <p class="non-para" @click="sortBy('FreqInDoc')">Frequency in Test Text</p>
                </th>
                <th>
                  <div class="btn-vertical">
                    <a href="#" @click="sortBy('Frequency')" v-if="sorting('Frequency', 'up')" class="btn-top"><i class="fa fa-caret-up"></i></a>
                    <a href="#" @click="sortBy('Frequency')" v-if="sorting('Frequency', 'down')" class="btn-bottom"><i class="fa fa-caret-down"></i></a>
                  </div>
                  <p class="non-para" @click="sortBy('Frequency')">Frequency</p>
                </th>
                <th style="width: 25%" class="col2">
                  <div class="btn-vertical">
                    <a href="#" @click="sortBy('Importance')" v-if="sorting('Importance', 'up')" class="btn-top"><i class="fa fa-caret-up"></i></a>
                    <a href="#" @click="sortBy('Importance')" v-if="sorting('Importance', 'down')" class="btn-bottom"><i class="fa fa-caret-down"></i></a>
                  </div>
                  <p class="non-para" @click="sortBy('Importance')">Importance for Classifying<br> This Chapter</p>
                </th>
                <th class="col2">
                  <div class="btn-vertical">
                    <a href="#" @click="sortBy('Significance')" v-if="sorting('Significance', 'up')" class="btn-top"><i class="fa fa-caret-up"></i></a>
                    <a href="#" @click="sortBy('Significance')" v-if="sorting('Significance', 'down')" class="btn-bottom"><i class="fa fa-caret-down"></i></a>
                  </div>
                  <p class="non-para" @click="sortBy('Significance')">Significance in<br> Distinguishing Classes</p>
                </th>
                <th style="display: none" class="col3">Chart</th>
              </tr>
              </thead>
              <template style="display: contents" v-for="(feature_set, class_index) in featureMap">
                <tbody v-for="(featureSetCategory, cat_index) in categorizedFeatureSetsArray(feature_set)" :key="class_index + '-' + cat_index">
                  <tr style="border-top: 1px solid rgb(173, 173, 173); border-bottom: 1px solid rgb(173, 173, 173);">
                    <td colspan="6"><strong style="padding: 10px 0;display: block;">{{ getClassName(class_index) }} {{ featureSetCategory[0] }} features [{{ featureSetCategory[1].length }}]</strong>
                    </td>
                  </tr>
                  <tr v-for="feature in featureSetCategory[1]" :key="feature._id">
                    <td><a class="gray" href="#" @click="showPopup('open', feature)"><p>{{ prettyPrint(chunkResults.featureList[feature].name) }}</p></a></td>
                    <td>{{ (chunkResults.featureList[feature].freqInDoc * 100).toFixed(2) }}%</td>
                    <td><div v-for="line in frequencyMiniTable(chunkResults.featureList[feature])" :title="line.title" :key="line.text">{{ line.text }}</div></td>
                    <td class="col2">
                      <div class="add-progressBar"><div v-bind:style="'width: ' + getSigTest(feature) + '%'"></div></div>
                    </td>
                    <td class="col2">
                      <div class="add-progressBar"><div v-bind:style="'width: ' + getSigClass(feature) + '%'"></div></div>
                    </td>
                    <td style="display: none" class="col3">
                      <div class="tooltip-holder chart">
                        <a @click="showInnerPopUp(class_index, feature, chunkResults.featureList[feature])"  class="view-chart blue">View</a>
                        <div v-bind:id="'chartbox-' + class_index + '-' + feature"  class="extra tooltip">
                          <div class="row">
                            <div class="col-xs-8">
                              <p>Chart</p>
                            </div>
                            <div class="col-xs-4">
                              <a class="cancel" @click="cancelClicked"><img class="tooltip-holder-img" src="../../assets/ic_cancel1.png"></a>
                            </div>
                          </div>
                          <div class="line-txt">
                            <a class="triangle" href="#"><img class="tooltip-holder-img" src="../../assets/Triangle.png"></a>
                            <a class="greenbox bg-green" href="#">greenbox</a>
                            <a class="blackbox bg-black" href="#">blackbox</a>
                          </div>
                          <div class="description">
                            <p class="test-info">Test Text</p>
                            <p class="winning-info"><span class="bg-green"></span> Winning Class </p>
                            <p class="other-info"><span class="bg-black"></span> Other Classes </p>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </template>
            </table>
          </div>
          <div class="baron__track">
            <div class="baron__bar"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</template>
<script>
import $ from 'jquery'
// (now used only in downloadFunctionMixins) import _ from 'lodash'
import 'jquery-ui-bundle'
import 'jquery-ui-bundle/jquery-ui.css'
import textMixins from '../../mixins/textMixins'
import {prettyPrint} from '../../mixins/featureNames'
import FeatureExamples from './featureExamples.vue'
import routeGlobals from '../../mixins/routeGlobals'

import downloadFunctionMixins from '../../mixins/downloadFunctionMixins'
// the above contains the functions frequencyMiniTable() and getClassName(),
// and also the functions categorizedFeatureSetsArray() and categorizeFeatureSet(),
// as well as their dependencies: categorizeFeatureSetName(),
// featureSortFunction(), and the data array "influenceCategories"

export default {
  name: 'advancedInfoPopup',
  components: { FeatureExamples },
  mixins: [textMixins, routeGlobals, downloadFunctionMixins],
  props: ['chunkResults'],
  data () {
    return {
      chosenFeature: 'not yet',
      /* sectionable: {
        'Feature': false,
        'Class': true,
        'Frequency in Test Text': false,
        'Frequency': false,
        'Significance in Test Text': true,
        'Significance in Classes': false // Because haven't worked out how (and not enabling yet)
      }, (COMMENTED BECAUSE DECIDED TO ONLY SECTION BY CLASS) */
      primaryKey: { name: 'Importance', defaultOrder: true },
      secondaryKey: { name: 'not yet', defaultOrder: true }
    }
  },
  computed: {
    chunkName: function () {
      // FIXME: hack to address the single chunk case, in which the server will return the first key for the chunk
      // instead of all the keys
      if (this.$store.state.chunking === 'SINGLE') {
        return this.testText.displayName
      }
      return this.chunkResults.name.split('/').slice(4, 6).join('/')
    },
    featureMap: function () {
      let map = {}
      /* if (!(this.sectionable[this.primaryKey])) {
        map['all'] = []
      } (COMMENTED BECAUSE DECIDED TO ONLY SECTION BY CLASS) */
      this.chunkResults.featureList.forEach((feature, index) => {
        /* if (this.sectionable[this.primaryKey]) {
          if (this.primaryKey === 'Class') { (COMMENTED BECAUSE DECIDED TO ONLY SECTION BY CLASS) */
        if (feature.orderByClass in map) { // remember in javascript "in" references the KEYS
          map[feature.orderByClass].push(index)
        } else {
          map[feature.orderByClass] = [index]
        }
      /* } else { // i.e. this.primaryKey === 'Significance in Test Text'
            if (this.categorizeFeatureSet(index) in map) { // remember in javascript "in" references the KEYS
              map[this.categorizeFeatureSet(index)].push(index)
            } else {
              map[this.categorizeFeatureSet(index)] = [index]
            }
          }
        } else map['all'].push(index) (COMMENTED BECAUSE DECIDED TO ONLY SECTION BY CLASS) */
      })
      console.log('featureMap:')
      console.log(map)
      return map
    },
    strongestInfluence: function () {
      let strongest = 0.0
      this.chunkResults.featureList.forEach(feature => {
        if (Math.abs(feature.influence) > strongest) { strongest = Math.abs(feature.influence) }
      })
      // console.log('strongest influence:')
      // console.log(strongest)
      return strongest
    },
    strongestTTestOfText: function () {
      let strongest = 0.0
      this.chunkResults.featureList.forEach(feature => {
        if (Math.abs(feature.tTest) > strongest) { strongest = Math.abs(feature.tTest) }
      })
      // console.log('strongest tTest:')
      // console.log(strongest)
      return strongest
    }
  },
  methods: {
    prettyPrint,
    openHelpTab () { // directories defined in routeGlobals
      window.open(this.helpRootDir + this.helpPagesSubDir + 'advanced-info.htm')
    },
    sortBy: function (keyName) {
      // this.primaryKey = this.secondaryKey
      // this.secondaryKey = keyName
      if (keyName === this.primaryKey.name) {
        this.primaryKey.defaultOrder = !this.primaryKey.defaultOrder
      } else {
        if (keyName === 'Class') {
          this.secondaryKey = this.primaryKey
        } else {
          this.secondaryKey = { name: keyName, defaultOrder: true }
        }
        this.primaryKey = { name: keyName, defaultOrder: true }
      }
      // this.sortFeaturesToShow()
    },
    sorting (keyName, dir) {
      // if ((keyName === this.primaryKey.name) || (keyName === this.secondaryKey.name)) {
      if (keyName === this.primaryKey.name) { // currently only displaying primary key
        var whichKey = ''
        if (keyName === this.primaryKey.name) {
          whichKey = 'primaryKey'
        } else {
          whichKey = 'secondaryKey'
        }
        if ((keyName === 'Feature') || (keyName === 'Class')) {
          if (dir === 'up') {
            return this[whichKey].defaultOrder
          } else return !(this[whichKey].defaultOrder)
        } else {
          if (dir === 'down') {
            return this[whichKey].defaultOrder
          } else return !(this[whichKey].defaultOrder)
        }
      } else return false
    },
    showPopup: function (action, featureIndex) {
      // Set the effect type
      var effect = 'slide'
      if (action === 'open') {
        // Set the duration (default: 400 milliseconds)
        var duration = 500
        $('#featuresShow').show(effect, {direction: 'right', queue: false}, duration).fadeIn({queue: false})
        $('#featuresShow').css({opacity: 0}).animate({opacity: 1}, 800)
        this.chosenFeature = {
          featureName: this.chunkResults.featureList[featureIndex].name,
          featureType: this.chunkResults.featureList[featureIndex].type
        } // this update activates the init function in featureExamples
      } else {
      // Set the effect type
        // Set the duration (default: 400 milliseconds)
        duration = 300
        $('#featuresShow').hide(effect, {direction: 'right', queue: false}, duration).fadeIn({queue: false})
      }
    },
    showInnerPopUp: function (classIndex, feature, featureObj) {
      var str = '#chartbox-' + classIndex + '-' + feature
      // console.log(str)
      $('.extra').hide()
      $(str + ' .triangle').css('left', '33%') // number should be obtained from featureObj
      $(str + ' .greenbox').css('left', '66%') // number should be obtained from featureObj
      $(str + ' .blackbox').css('left', '95%') // number should be obtained from featureObj
      $(str).show()
    },
    cancelClicked () {
      // document.getElementsByClassName('extra').style.setProperty('display', 'none')
      $('.extra').hide()
    },
    textColor (result) {
      return 'bg-class bg-class-' + (result.classID % 5)
    },
    getVars (featureSet, classIndex) {
      // console.log('featureSet:')
      // console.log(featureSet)
      // console.log('classIndex:')
      // console.log(classIndex)
      return 'temp'
    },
    autoWrap (s, n) { // adapted from stackoverflow - breaks feature name into 'words' of 'n' length
      let a = [].concat.apply([], s.split('').map(function (x, i) { return i % n ? [] : s.slice(i, i + n) }))
      return a.join(' ')
    },
    getSigTest (featureIndex) {
      let sigPercent = Math.abs(this.chunkResults.featureList[featureIndex].influence) / this.strongestInfluence * 100
      return sigPercent
    },
    getSigClass (featureIndex) {
      let sigPercent = Math.abs(this.chunkResults.featureList[featureIndex].tTest) / this.strongestTTestOfText * 100
      return sigPercent
    }
  },
  mounted: function () {
    console.log(this.classes)
    // console.log('chunkResults:')
    // console.log(this.chunkResults)
    // console.log('chunkName:')
    // console.log(this.chunkName)
  }
}
</script>
<style scoped>
  /* to keep the box-shadow over the table header*/
  #view_advanced_information .text {
    z-index: 10
  }
  th {
    position: sticky;
    z-index: 9;
    top: 0;
    background: white;
  }
  /* from https://stackoverflow.com/a/45042852/7200693 because border-bottom disappears when sticky */
  th:after{
    content:'';
    position:absolute;
    left: 0;
    bottom: 0;
    width:100%;
    border-bottom: solid 1px #adadad;
  }
  .non-para{
    /* margin: 0;
    padding: 0 0 0 0 !important;
    display: inline-block;
    vertical-align: middle; */
    cursor: pointer;
    /* letter-spacing: 0.2px;
    color: #646464; */
  }
  .non-para:hover{
    text-decoration: underline;
  }

</style>



// WEBPACK FOOTER //
// src/components/experiment/advancedInfoPopup.vue